import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './redux/reducers'
import { loadState, saveState } from './sessionStorage'

const persistedState = loadState()
const middleware = [thunk]
const store = createStore(
    rootReducer,
    persistedState,
    applyMiddleware(...middleware)
)

store.subscribe(() => {
    saveState(store.getState())
})

export default store



// WEBPACK FOOTER //
// ./resources/js/store.js